(function () {
  'use strict';

  // ── CSS (scoped under .jn-bsm) ──────────────────────────────────────────
  const CSS = `
.jn-bsm-overlay{position:fixed;inset:0;background:rgba(26,23,20,.52);display:flex;align-items:center;justify-content:center;opacity:0;transition:opacity .28s ease}
.jn-bsm-overlay.open{opacity:1}
@media(max-width:600px){.jn-bsm-overlay{align-items:flex-start}}
dialog.jn-bsm-overlay{padding:0;border:none;margin:0;width:100vw;max-width:100vw;height:100dvh;max-height:100dvh;overflow:hidden}
dialog.jn-bsm-overlay::backdrop{display:none}
.jn-bsm{--dark:#1A1714;--mid:#3D3730;--gold:#8B6F4E;--lgold:#C4A882;--beige:#EDE5D8;--lbeige:#F3EDE4;--border:#E2D9CC;--muted:#8A8178;--warm-white:#FDFBF8;--cream:#F8F4EE;font-family:'Inter',sans-serif;-webkit-font-smoothing:antialiased;background:var(--cream);color:var(--dark);position:relative;overflow-y:auto;width:100%;max-width:800px;max-height:90vh}
@media(max-width:600px){.jn-bsm{max-width:100%;max-height:100dvh;height:100dvh}}
.jn-bsm *,.jn-bsm *::before,.jn-bsm *::after{box-sizing:border-box;margin:0;padding:0}
.jn-bsm-close{position:absolute;top:16px;right:18px;z-index:10;background:none;border:none;cursor:pointer;font-size:20px;color:var(--muted);line-height:1;padding:6px;transition:color .2s;font-family:sans-serif}
.jn-bsm-close:hover{color:var(--dark)}
.jn-bsm-prog{position:absolute;top:0;left:0;height:2px;background:var(--dark);transition:width .4s ease;z-index:10}
.jn-bsm .screen{opacity:0;transform:translateY(10px);transition:opacity .3s ease,transform .3s ease}
.jn-bsm .screen.active{opacity:1;transform:none}
.jn-bsm .qlabel{font-family:'Inter',sans-serif;font-size:10px;letter-spacing:.22em;text-transform:uppercase;color:var(--gold);margin-bottom:14px;display:block}
.jn-bsm .qtitle{font-family:'Cormorant Garamond',serif;font-size:clamp(26px,4vw,42px);font-weight:400;line-height:1.15}
.jn-bsm .qsub{font-size:14px;font-weight:300;color:var(--muted);margin-top:10px;line-height:1.7}
.jn-bsm .qsub-gold{font-size:13px;color:var(--gold);margin-top:8px;margin-bottom:4px}
.jn-bsm .btn{display:inline-flex;align-items:center;gap:10px;font-family:'Inter',sans-serif;font-size:11px;font-weight:500;letter-spacing:.15em;text-transform:uppercase;border:none;cursor:pointer;transition:all .22s ease}
.jn-bsm .btn-d{padding:14px 36px;background:var(--dark);color:var(--warm-white)}
.jn-bsm .btn-d:hover{background:var(--mid)}
.jn-bsm .btn-d:disabled{opacity:.35;cursor:not-allowed}
.jn-bsm .btn-g{padding:12px 22px;background:transparent;color:var(--muted);border:1.5px solid var(--border)}
.jn-bsm .btn-g:hover{color:var(--dark);border-color:var(--dark)}
.jn-bsm .qnav{display:flex;align-items:center;justify-content:center;gap:14px;margin-top:40px;flex-wrap:wrap}
.jn-bsm .fside-l .qnav{justify-content:flex-start}
@media(max-width:600px){.jn-bsm .fside-l .qnav{justify-content:center}}
.jn-bsm .qwrap{padding:44px 36px 52px}
.jn-bsm .qhead{text-align:center;margin-bottom:36px}
.jn-bsm .sgrid{display:grid;grid-template-columns:1fr 1fr;gap:16px;max-width:600px;margin:0 auto}
@media(max-width:500px){.jn-bsm .sgrid{grid-template-columns:1fr}}
.jn-bsm .scard{padding:32px 18px;background:white;border:1.5px solid var(--border);cursor:pointer;text-align:center;transition:border-color .22s,background .22s,transform .22s}
.jn-bsm .scard:hover{border-color:var(--dark);background:var(--lbeige);transform:translateY(-2px)}
.jn-bsm .scard-icon{font-size:24px;margin-bottom:10px}
.jn-bsm .scard-title{font-family:'Cormorant Garamond',serif;font-size:19px;font-weight:400;margin-bottom:6px}
.jn-bsm .scard-desc{font-size:12px;color:var(--muted);line-height:1.6}
.jn-bsm .fwrap{padding:44px 36px 52px;text-align:center}
.jn-bsm .sselects{display:grid;grid-template-columns:1fr 1fr;gap:14px;max-width:320px;margin:24px auto}
.jn-bsm .ssel-w label{font-size:10px;letter-spacing:.18em;text-transform:uppercase;color:var(--muted);display:block;margin-bottom:7px;font-family:'Inter',sans-serif}
.jn-bsm .ssel{width:100%;padding:13px 32px 13px 14px;background:white;border:1.5px solid var(--border);font-family:'Cormorant Garamond',serif;font-size:24px;color:var(--dark);outline:none;cursor:pointer;appearance:none;-webkit-appearance:none;background-image:url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='11' height='7' viewBox='0 0 11 7'%3E%3Cpath d='M1 1l4.5 4.5L10 1' stroke='%238A8178' fill='none' stroke-width='1.5' stroke-linecap='round'/%3E%3C/svg%3E");background-repeat:no-repeat;background-position:right 12px center;transition:border-color .2s}
.jn-bsm .ssel:focus{border-color:var(--dark)}
.jn-bsm .fpage{padding:40px 36px 52px;display:grid;grid-template-columns:1fr 1fr;gap:48px;align-items:center}
@media(max-width:600px){.jn-bsm .fpage{grid-template-columns:1fr;gap:0;padding:32px 20px 44px}}
.jn-bsm .fside-l{display:flex;flex-direction:column;align-items:flex-start}
@media(max-width:600px){.jn-bsm .fside-l{order:2;padding-top:28px;align-items:center;text-align:center}}
@media(max-width:600px){.jn-bsm .fside-r{order:1}}
.jn-bsm .fimg-wrap{position:relative;width:100%;height:420px;background:var(--lbeige)}
.jn-bsm .fillus{display:block;width:100%;height:100%;object-fit:contain;object-position:center center}
@media(max-width:600px){.jn-bsm .fimg-wrap{height:240px}}
.jn-bsm .fimg-cap{position:absolute;bottom:0;left:0;right:0;background:rgba(26,23,20,.62);-webkit-backdrop-filter:blur(4px);backdrop-filter:blur(4px);padding:14px 18px 16px;border-top:1px solid rgba(255,255,255,.12)}
.jn-bsm .fimg-cap-label{font-family:'Inter',sans-serif;font-size:9px;letter-spacing:.24em;text-transform:uppercase;color:rgba(196,168,130,.85);margin-bottom:6px}
.jn-bsm .fimg-cap-quote{font-family:'Cormorant Garamond',serif;font-size:14px;font-style:italic;font-weight:400;line-height:1.6;color:rgba(255,255,255,.9)}
.jn-bsm .utog{display:flex;justify-content:flex-start;margin:32px 0 8px}
@media(max-width:600px){.jn-bsm .utog{justify-content:center}}
.jn-bsm .ubtn{padding:7px 20px;border:1.5px solid var(--border);background:white;font-size:11px;font-weight:500;letter-spacing:.1em;text-transform:uppercase;cursor:pointer;transition:all .2s;font-family:'Inter',sans-serif;color:var(--muted)}
.jn-bsm .ubtn:first-child{border-right:none}
.jn-bsm .ubtn.on{background:var(--dark);color:white;border-color:var(--dark)}
.jn-bsm .minp-g{margin:8px 0 0;width:100%;max-width:240px}
@media(max-width:600px){.jn-bsm .minp-g{margin:8px auto 0}}
.jn-bsm .minp-l{font-size:10px;letter-spacing:.18em;text-transform:uppercase;color:var(--muted);margin-bottom:8px;display:block;font-family:'Inter',sans-serif}
.jn-bsm .minp{width:100%;padding:11px 12px;background:white;border:1.5px solid var(--border);font-family:'Cormorant Garamond',serif;font-size:30px;text-align:center;color:var(--dark);outline:none;transition:border-color .2s;-moz-appearance:textfield}
.jn-bsm .minp::-webkit-inner-spin-button,.jn-bsm .minp::-webkit-outer-spin-button{-webkit-appearance:none}
.jn-bsm .minp:focus{border-color:var(--dark)}
.jn-bsm .munit{font-size:12px;color:var(--muted);margin-top:5px}
.jn-bsm .szdisp{font-family:'Cormorant Garamond',serif;font-size:70px;font-weight:300;line-height:1;margin:16px 0 8px}
.jn-bsm .szbreak{font-size:13px;color:var(--muted);margin-bottom:16px}
.jn-bsm .szbreak strong{color:var(--dark)}
.jn-bsm .sislbl{font-size:10px;letter-spacing:.18em;text-transform:uppercase;color:var(--muted);margin-bottom:8px}
.jn-bsm .sispills{display:flex;gap:10px;justify-content:center;margin-bottom:22px}
.jn-bsm .sispill{padding:5px 15px;border:1px solid var(--border);font-size:14px;color:var(--muted);font-family:'Cormorant Garamond',serif}
.jn-bsm .fnote{background:var(--lbeige);border-left:2px solid var(--lgold);padding:14px 18px 16px;margin:20px auto;max-width:420px;text-align:left}
.jn-bsm .fnote-label{font-family:'Inter',sans-serif;font-size:9px;letter-spacing:.24em;text-transform:uppercase;color:var(--gold);margin-bottom:7px}
.jn-bsm .fnote-quote{font-family:'Cormorant Garamond',serif;font-size:15px;font-style:italic;font-weight:400;line-height:1.65;color:var(--mid)}
`;

  // ── STATE ───────────────────────────────────────────────────────────────
  let S = {
    screen: 'bra_know_size',
    history: ['bra_know_size'],
    unit: 'in',
    bandIn: '',
    bustIn: '',
    braSize: null,
    braFromCookie: false,
  };

  // ── HELPERS ─────────────────────────────────────────────────────────────
  function setCookie(n, v, days) {
    document.cookie = n + '=' + encodeURIComponent(v) + ';max-age=' + (days * 86400) + ';path=/;SameSite=Lax';
  }
  function getCookie(n) {
    const c = document.cookie.split(';').map(s => s.trim()).find(s => s.startsWith(n + '='));
    return c ? decodeURIComponent(c.slice(n.length + 1)) : null;
  }
  function saveBraSize(sz) {
    setCookie('jfq_bra_sz', JSON.stringify({ band: sz.band, cup: sz.cup, full: sz.full }), 365);
  }
  function calcSize(band, bust, unit) {
    let b = parseFloat(band), f = parseFloat(bust);
    if (unit === 'cm') { b /= 2.54; f /= 2.54; }
    let bs = Math.round(b);
    if (bs % 2 !== 0) bs++;
    bs = Math.max(28, Math.min(50, bs));
    const cups = ['AA', 'A', 'B', 'C', 'D', 'DD', 'DDD', 'G', 'H', 'I'];
    const cup = cups[Math.min(Math.round(Math.max(0, f - b)), cups.length - 1)];
    return { band: bs, cup, full: `${bs}${cup}` };
  }
  function sisters({ band, cup }) {
    const cups = ['AA', 'A', 'B', 'C', 'D', 'DD', 'DDD', 'G', 'H', 'I'];
    const ci = cups.indexOf(cup), out = [];
    if (band >= 30 && ci < cups.length - 1) out.push(`${band - 2}${cups[ci + 1]}`);
    if (band <= 44 && ci > 0) out.push(`${band + 2}${cups[ci - 1]}`);
    return out;
  }
  function tog(id, on) {
    const el = document.getElementById(id);
    if (!el) return;
    el.disabled = !on;
    el.style.opacity = on ? '1' : '.35';
    el.style.cursor = on ? 'pointer' : 'not-allowed';
  }

  // ── NAVIGATION ──────────────────────────────────────────────────────────
  const PROGRESS = { bra_know_size: 0, bra_enter_size: 50, fit_band: 25, fit_bust: 58, fit_result: 90 };

  function goTo(s) { S.history.push(s); S.screen = s; render(); }
  function goBack() {
    if (S.history.length > 1) { S.history.pop(); S.screen = S.history[S.history.length - 1]; render(); }
  }
  function backBtn() {
    return S.history.length > 1
      ? '<button class="btn btn-g" onclick="window.jnBSM.goBack()">&#8592; Back</button>'
      : '';
  }

  // ── SCREEN TEMPLATES ────────────────────────────────────────────────────
  function rBraKnow() {
    return `<div class="screen"><div class="qwrap">
  <div class="qhead">
    <span class="qlabel">Bra Sizing</span>
    <h2 class="qtitle">Do you know<br>your bra size?</h2>
  </div>
  <div class="sgrid">
    <div class="scard" onclick="window.jnBSM.goTo('bra_enter_size')">
      <div class="scard-icon">&#10003;</div>
      <div class="scard-title">Yes, I know my size</div>
      <div class="scard-desc">Enter your size and save it to your fit profile</div>
    </div>
    <div class="scard" onclick="window.jnBSM.goTo('fit_band')">
      <div class="scard-icon">&#128207;</div>
      <div class="scard-title">Help me find my size</div>
      <div class="scard-desc">Our guided measurement process takes just two minutes</div>
    </div>
  </div>
  <div class="qnav">${backBtn()}</div>
</div></div>`;
  }

  function rBraEnter() {
    if (!S.braSize) {
      try {
        const sv = getCookie('jfq_bra_sz');
        if (sv) { S.braSize = JSON.parse(sv); S.braFromCookie = true; }
      } catch (e) {}
    }
    const bands = [28, 30, 32, 34, 36, 38, 40, 42, 44, 46, 48];
    const cups = ['AA', 'A', 'B', 'C', 'D', 'DD', 'DDD', 'G', 'H', 'I'];
    const cb = S.braSize?.band || '', cc = S.braSize?.cup || '', ok = !!(cb && cc);
    const savedNote = S.braFromCookie
      ? '<p class="qsub qsub-gold">We remembered your size from your last visit — update below to change it.</p>'
      : '<p class="qsub">We’ll use this to surface styles in your size.</p>';
    return `<div class="screen"><div class="fwrap">
  <span class="qlabel">Bra Sizing</span>
  <h2 class="qtitle">Enter your bra size</h2>
  ${savedNote}
  <div class="sselects">
    <div class="ssel-w"><label>Band</label>
      <select class="ssel" id="jbsm-bsel" onchange="window.jnBSM.syncEntered()">
        <option value="">—</option>
        ${bands.map(b => `<option value="${b}"${cb == b ? ' selected' : ''}>${b}</option>`).join('')}
      </select></div>
    <div class="ssel-w"><label>Cup</label>
      <select class="ssel" id="jbsm-csel" onchange="window.jnBSM.syncEntered()">
        <option value="">—</option>
        ${cups.map(c => `<option value="${c}"${cc == c ? ' selected' : ''}>${c}</option>`).join('')}
      </select></div>
  </div>
  <div class="qnav">
    ${backBtn()}
    <button class="btn btn-d" id="jbsm-esbtn" onclick="window.jnBSM.confirmEntered()" ${ok ? '' : 'disabled'} style="${ok ? '' : 'opacity:.35;cursor:not-allowed'}">Save My Size &nbsp;&#8594;</button>
  </div>
</div></div>`;
  }

  function rFitBand() {
    const ph = S.unit === 'in' ? '30' : '76', ok = !!S.bandIn;
    return `<div class="screen"><div class="fpage">
  <div class="fside-l">
    <span class="qlabel">Step 1 of 2 — Band Measurement</span>
    <h2 class="qtitle">Measure your<br>band size</h2>
    <div class="utog">
      <button class="ubtn ${S.unit === 'in' ? 'on' : ''}" onclick="window.jnBSM.setUnit('in')">Inches</button>
      <button class="ubtn ${S.unit === 'cm' ? 'on' : ''}" onclick="window.jnBSM.setUnit('cm')">CM</button>
    </div>
    <div class="minp-g">
      <label class="minp-l">Your measurement</label>
      <input class="minp" type="number" id="jbsm-bi" value="${S.bandIn}" placeholder="${ph}" step="0.5" min="20" max="60" oninput="window.jnBSM.onBandInput(this.value)">
      <div class="munit">${S.unit === 'in' ? 'inches' : 'centimetres'}</div>
    </div>
    <div class="qnav">
      ${backBtn()}
      <button class="btn btn-d" id="jbsm-bbnxt" onclick="window.jnBSM.goTo('fit_bust')" ${ok ? '' : 'disabled'} style="${ok ? '' : 'opacity:.35;cursor:not-allowed'}">Next &nbsp;&#8594;</button>
    </div>
  </div>
  <div class="fside-r">
    <div class="fimg-wrap">
      <img class="fillus" src="https://cdn.shopify.com/s/files/1/1658/2831/files/band-measure.png?v=1781363266&width=600" alt="Band measurement illustration">
      <div class="fimg-cap">
        <div class="fimg-cap-label">Fitter’s Notes</div>
        <div class="fimg-cap-quote">"Wrap the tape firmly but comfortably around your ribcage, directly under your bust. Keep it level all the way around."</div>
      </div>
    </div>
  </div>
</div></div>`;
  }

  function rFitBust() {
    const ph = S.unit === 'in' ? '36' : '91', ok = !!S.bustIn;
    return `<div class="screen"><div class="fpage">
  <div class="fside-l">
    <span class="qlabel">Step 2 of 2 — Bust Measurement</span>
    <h2 class="qtitle">Now measure<br>your bust</h2>
    <div class="utog">
      <button class="ubtn ${S.unit === 'in' ? 'on' : ''}" onclick="window.jnBSM.setUnit('in')">Inches</button>
      <button class="ubtn ${S.unit === 'cm' ? 'on' : ''}" onclick="window.jnBSM.setUnit('cm')">CM</button>
    </div>
    <div class="minp-g">
      <label class="minp-l">Your measurement</label>
      <input class="minp" type="number" id="jbsm-fbi" value="${S.bustIn}" placeholder="${ph}" step="0.5" min="24" max="70" oninput="window.jnBSM.onBustInput(this.value)">
      <div class="munit">${S.unit === 'in' ? 'inches' : 'centimetres'}</div>
    </div>
    <div class="qnav">
      ${backBtn()}
      <button class="btn btn-d" id="jbsm-fbnxt" onclick="window.jnBSM.doCalc()" ${ok ? '' : 'disabled'} style="${ok ? '' : 'opacity:.35;cursor:not-allowed'}">Calculate My Size &nbsp;&#8594;</button>
    </div>
  </div>
  <div class="fside-r">
    <div class="fimg-wrap">
      <img class="fillus" src="https://cdn.shopify.com/s/files/1/1658/2831/files/bust-measure.png?v=1781363828&width=600" alt="Bust measurement illustration">
      <div class="fimg-cap">
        <div class="fimg-cap-label">Fitter’s Notes</div>
        <div class="fimg-cap-quote">"Wrap the tape around the fullest part of your chest, parallel to the floor. Keep it relaxed — you should be able to slide two fingers underneath."</div>
      </div>
    </div>
  </div>
</div></div>`;
  }

  function rFitResult() {
    const sz = S.braSize, sis = sisters(sz);
    return `<div class="screen"><div class="fwrap">
  <span class="qlabel">Your Fit Result</span>
  <h2 class="qtitle">Your size is</h2>
  <div class="szdisp">${sz.full}</div>
  <p class="szbreak">Band <strong>${sz.band}</strong> &nbsp;&middot;&nbsp; Cup <strong>${sz.cup}</strong></p>
  ${sis.length ? `<p class="sislbl">Sister sizes</p><div class="sispills">${sis.map(s => `<span class="sispill">${s}</span>`).join('')}</div>` : ''}
  <div class="fnote">
    <div class="fnote-label">Fitter’s Notes</div>
    <div class="fnote-quote">"Sister sizes share the same cup volume. If ${sz.full} feels tight in the band, try the size above — same cup in a looser band."</div>
  </div>
  ${sz.cup === 'DD' ? `<div class="fnote"><div class="fnote-label">Fitter’s Notes</div><div class="fnote-quote">"Many brands — particularly European and British labels — mark this cup as E rather than DD. If you see ${sz.band}E on a label, that is your size."</div></div>` : ''}
  ${sz.cup === 'DDD' ? `<div class="fnote"><div class="fnote-label">Fitter’s Notes</div><div class="fnote-quote">"Many brands — particularly European and British labels — mark this cup as F rather than DDD. If you see ${sz.band}F on a label, that is your size."</div></div>` : ''}
  <div class="qnav">
    <button class="btn btn-d" onclick="window.jnBSM.closeModal()">Done — close</button>
  </div>
</div></div>`;
  }

  // ── ACTIONS ─────────────────────────────────────────────────────────────
  function onBandInput(v) { S.bandIn = v; tog('jbsm-bbnxt', !!v); }
  function onBustInput(v) { S.bustIn = v; tog('jbsm-fbnxt', !!v); }

  function setUnit(u) {
    const bandEl = document.getElementById('jbsm-bi');
    const bustEl = document.getElementById('jbsm-fbi');
    if (bandEl) S.bandIn = bandEl.value;
    if (bustEl) S.bustIn = bustEl.value;
    S.unit = u;
    render();
  }

  function syncEntered() {
    const b = document.getElementById('jbsm-bsel')?.value;
    const c = document.getElementById('jbsm-csel')?.value;
    if (b && c) S.braSize = { band: parseInt(b), cup: c, full: `${b}${c}` };
    tog('jbsm-esbtn', !!(b && c));
  }

  function confirmEntered() {
    if (!S.braSize) return;
    saveBraSize(S.braSize);
    S.braFromCookie = false;
    closeModal();
  }

  function doCalc() {
    if (!S.bustIn) return;
    S.braSize = calcSize(S.bandIn, S.bustIn, S.unit);
    saveBraSize(S.braSize);
    goTo('fit_result');
  }

  // ── RENDER ──────────────────────────────────────────────────────────────
  function screenHTML() {
    if (S.screen === 'bra_enter_size') return rBraEnter();
    if (S.screen === 'fit_band')       return rFitBand();
    if (S.screen === 'fit_bust')       return rFitBust();
    if (S.screen === 'fit_result')     return rFitResult();
    return rBraKnow();
  }

  function render() {
    const app = document.getElementById('jn-bsm-app');
    if (!app) return;
    app.innerHTML = screenHTML();
    const prog = document.getElementById('jn-bsm-prog');
    if (prog) prog.style.width = (PROGRESS[S.screen] || 0) + '%';
    requestAnimationFrame(() => requestAnimationFrame(() => {
      const sc = app.querySelector('.screen');
      if (sc) sc.classList.add('active');
    }));
  }

  // ── MODAL DOM ───────────────────────────────────────────────────────────
  let overlay = null;

  function ensureFonts() {
    if (!document.getElementById('jn-bsm-fonts')) {
      const link = document.createElement('link');
      link.id = 'jn-bsm-fonts';
      link.rel = 'stylesheet';
      link.href = 'https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,300;0,400;1,300;1,400&family=Inter:wght@300;400;500;600&display=swap';
      document.head.appendChild(link);
    }
  }

  function injectCSS() {
    if (!document.getElementById('jn-bsm-style')) {
      const st = document.createElement('style');
      st.id = 'jn-bsm-style';
      st.textContent = CSS;
      document.head.appendChild(st);
    }
  }

  function onKeyDown(e) {
    if (e.key === 'Escape') closeModal();
  }

  function openModal() {
    if (overlay) return;
    ensureFonts();
    injectCSS();

    S = { screen: 'bra_know_size', history: ['bra_know_size'], unit: 'in', bandIn: '', bustIn: '', braSize: null, braFromCookie: false };

    overlay = document.createElement('dialog');
    overlay.className = 'jn-bsm-overlay';
    overlay.setAttribute('aria-label', 'Find your bra size');
    overlay.innerHTML = `<div class="jn-bsm" id="jn-bsm-panel">
  <div class="jn-bsm-prog" id="jn-bsm-prog" style="width:0%"></div>
  <button class="jn-bsm-close" onclick="window.jnBSM.closeModal()" aria-label="Close">✕</button>
  <div id="jn-bsm-app"></div>
</div>`;

    document.body.appendChild(overlay);
    document.body.style.overflow = 'hidden';
    overlay.showModal();

    // Force full-viewport coverage — iOS Safari UA dialog styles resist CSS class overrides
    overlay.style.setProperty('position', 'fixed', 'important');
    overlay.style.setProperty('inset', '0', 'important');
    overlay.style.setProperty('width', '100%', 'important');
    overlay.style.setProperty('height', '100%', 'important');
    overlay.style.setProperty('max-width', 'none', 'important');
    overlay.style.setProperty('max-height', 'none', 'important');
    overlay.style.setProperty('padding', '0', 'important');
    overlay.style.setProperty('border', 'none', 'important');
    overlay.style.setProperty('margin', '0', 'important');

    // Intercept native Escape-key close so our animation and event fire correctly
    overlay.addEventListener('cancel', function (e) { e.preventDefault(); closeModal(); });

    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) closeModal();
    });

    render();

    requestAnimationFrame(() => overlay.classList.add('open'));
  }

  function closeModal() {
    if (!overlay) return;
    const el = overlay;
    overlay = null;
    el.classList.remove('open');
    setTimeout(function () {
      document.body.style.overflow = '';
      el.close();
      if (el.parentNode) el.parentNode.removeChild(el);
      document.dispatchEvent(new CustomEvent('jnBraSizeSet', { bubbles: true }));
    }, 300);
  }

  // ── PUBLIC API ───────────────────────────────────────────────────────────
  window.jnBSM = { openModal, closeModal, goTo, goBack, syncEntered, confirmEntered, doCalc, setUnit, tog, onBandInput, onBustInput };
  window.jnOpenBraModal = openModal;

})();
